// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","list":"NumberedList_list__Y8e64","item":"NumberedList_item__JBslG"};